import React from 'react';
import { connect } from 'react-redux';
import { notify } from 'reapop';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';

import { notificationConfig } from '../../utils/helpers/general';
import { historyNotesModalName } from '../../utils/constants/ModalNames';

import RequestService from '../../utils/services/RequestsService';

import {
  showModal,
  initNotesModalByRequestId,
  showSpinner,
  resetNotesModal,
} from '../../actions/general';

import { CanCreateLoanApplicationNote } from '../HOC/Authorize';

import '../../css/modal/history.css';

class HistoryNotesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { privateNote: true, note: '', activityType: '', error: '' };
  }

  closeForm = () => {
    const { showModal, resetNotesModal } = this.props;
    this.setState(
      {
        note: '',
        privateNote: true,
        activityType: '',
        error: '',
      },
      () => {
        resetNotesModal();
        showModal(historyNotesModalName, false);
      }
    );
  };

  validation = activityType =>
    activityType === '' ? true : this.setState({ error: '' });

  onChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  renderActivityType = activityType => {
    switch (activityType) {
      case 'contacto_cliente':
        return 'Contacto cliente';
      case 'contacto_broker':
        return 'Contacto broker';
      case 'asignado_notaria':
        return 'Asignado notario';
      case 'nuevo_cliente':
        return 'Nuevo cliente';
      case 'cierre_exitoso':
        return 'Cierre exitoso';
      case 'cierre_no_satisfactorio':
        return 'Cierre no satisfactorio';
      case 'asignacion_enviada':
        return 'Asignación enviada';
      case 'nota_del_sistema':
        return 'Nota del sistema';
      case 'visita_cliente':
        return 'Visita a cliente';
      case 'soporte_tecnico':
        return 'Soporte técnico';
      case 'mesa_de_control':
        return 'Mesa de control';
      case 'riesgos':
        return 'Riesgos';
      default:
        return '';
    }
  };

  updateRequestNote = () => {
    const { requestId, initNotesModalByRequestId, name } = this.props;
    const { note, privateNote, activityType } = this.state;
    if (this.validation(activityType)) {
      this.setState({ error: 'Este campo es requerido' });
    } else {
      if (!note) return;
      RequestService.updateRequestNote(
        requestId,
        note,
        privateNote,
        activityType,
        name
      )
        .then(data => {
          this.setState({
            note: '',
            privateNote: true,
            activityType: '',
          });
          initNotesModalByRequestId(requestId);

          this.props.notify(
            notificationConfig('Satifactorio!', 'Nota creada', 'success')
          );
        })
        .catch(err => {
          const { REACT_APP_ENABLE_LOG_ROCKET: enableLog } = process.env;
          const { LogRocket } = window;
          if (enableLog === 'true' && LogRocket) {
            LogRocket.captureException(err, {
              tags: {
                // additional data to be grouped as "tags"
                subscription: 'pro',
              },
              extra: {
                // additional arbitrary data associated with the event
                pageName: 'Notes Form',
                action: `Updating notes for request ${requestId}`,
              },
            });
          }
          this.props.notify(
            notificationConfig('Error', 'Error actualizando notas!', 'error')
          );
        })
        .finally(() => showSpinner(false));
    }
  };

  render() {
    const { show, disabled } = this.props;
    const { privateNote, note, error, activityType } = this.state;

    const notes = [...this.props.notes].map((n, i) =>
      n.Historial !== '' ? (
        <li className="list-group-item" key={i}>
          <p className="history-value">{n.value}</p>

          <p className="history-author d-flex align-items-center">
            <span className="text-bold d-flex align-items-center">
              <i className="fa fa-user-circle" />{' '}
              {n.authorName || ' sin nombre'}
            </span>
            <span className="history-divition"> | </span>
            <span className="d-flex align-items-center">
              <i className="fa sli-clock" />{' '}
              {moment(n.createdAt).format('DD/MM/YYYY - hh:mm a')}
            </span>
            {n.activityType && (
              <React.Fragment>
                <span className="history-divition"> | </span>
                <span className="d-flex align-items-center">
                  <i className="fa fa-sticky-note-o" />{' '}
                  {this.renderActivityType(n.activityType)}
                </span>
              </React.Fragment>
            )}
          </p>
        </li>
      ) : null
    );

    return (
      <Modal toggle={this.closeForm} isOpen={show} size="lg">
        <ModalHeader toggle={this.closeForm}>Historial</ModalHeader>
        <ModalBody>
          <div className="content-nota">
            <div className="d-flex justify-content-between">
              <select
                className="form-control w-50 mb-2"
                id="dropdownMenu2"
                disabled={disabled}
                name="activityType"
                onChange={this.onChange}
                value={activityType}
              >
                <option value="">Seleccione tipo de nota: </option>
                <option value="asignado_notaria">Asignado notario</option>
                <option value="contacto_cliente">Contacto cliente</option>
                <option value="contacto_broker">Contacto broker</option>
                <option value="cierre_exitoso">Cierre exitoso</option>
                <option value="nuevo_cliente">Nuevo cliente</option>
                <option value="visita_cliente">Visita a cliente</option>
                <option value="cierre_no_satisfactorio">
                  Cierre no satisfactorio
                </option>
                <option value="asignacion_enviada">Asignación enviada</option>
                <option value="soporte_tecnico">Soporte técnico</option>
                <option value="mesa_de_control">Mesa de control</option>
                <option value="riesgos">Riesgos</option>
              </select>
            </div>
            {activityType === '' && (
              <span
                style={{
                  color: 'red',
                  width: '100%',
                  position: 'relative',
                  top: '-10px',
                }}
              >
                {' '}
                {error}
              </span>
            )}
            <div className="form-group">
              <textarea
                className="form-control"
                value={note || ''}
                name="note"
                rows="6"
                onChange={this.onChange}
              />
              <div className="d-flex justify-content-between history-options">
                <label htmlFor="">
                  <input
                    type="checkbox"
                    name="privateNote"
                    value={privateNote}
                    checked={privateNote}
                    onChange={() =>
                      this.setState({
                        privateNote: !privateNote,
                      })
                    }
                  />{' '}
                  Hacer esta nota privada
                </label>
                <div>
                  <CanCreateLoanApplicationNote>
                    <button
                      className="btn btn-secondary btn-saveHistory"
                      type="button"
                      onClick={this.updateRequestNote}
                    >
                      Guardar
                    </button>
                  </CanCreateLoanApplicationNote>
                  <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={this.closeForm}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="content-history">
            <ul className="list-group">{notes}</ul>
          </div>
        </ModalBody>
        <ModalFooter />
      </Modal>
    );
  }
}
const mapStateToProps = state => {
  const { ui, notesModal, user } = state;
  const show = ui[historyNotesModalName] || false;
  const { notes, requestId } = notesModal;
  return {
    show,
    notes,
    requestId,
    name: user.name,
  };
};
export default connect(
  mapStateToProps,
  {
    showSpinner,
    showModal,
    initNotesModalByRequestId,
    notify,
    resetNotesModal,
  }
)(HistoryNotesModal);



// WEBPACK FOOTER //
// ./src/components/modals/HistoryNotesModal.js